import { render, staticRenderFns } from "./dubbing.vue?vue&type=template&id=1309451b&scoped=true"
import script from "./dubbing.vue?vue&type=script&lang=js"
export * from "./dubbing.vue?vue&type=script&lang=js"
import style0 from "./dubbing.vue?vue&type=style&index=0&id=1309451b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309451b",
  null
  
)

export default component.exports